import { render } from "./Typescript.vue?vue&type=template&id=9d132648&ts=true"
import script from "./Typescript.vue?vue&type=script&lang=ts"
export * from "./Typescript.vue?vue&type=script&lang=ts"

import "./Typescript.vue?vue&type=style&index=0&id=9d132648&lang=css"

import exportComponent from "C:\\Dev\\Perso\\vue-upload-component\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__